import { readCartMessage } from './cartMessages';

export function calculateItemDiscount(item, appliedBenefits = []) {
  let itemDiscount = 0;
  let freeQty = 0;

  appliedBenefits.forEach((benefit) => {
    const isExcludedByProduct =
      Array.isArray(benefit?.excludeProducts) &&
      benefit.excludeProducts.includes(item.productNumber);
    const isExcludedByCategory =
      Array.isArray(benefit?.excludeCategories) &&
      Array.isArray(item.categories) &&
      item.categories.some((category) =>
        benefit.excludeCategories.includes(category?.categoryNumber),
      );

    if (isExcludedByProduct || isExcludedByCategory) {
      return;
    }

    const appliesToProduct =
      !Array.isArray(benefit?.applicableProducts) ||
      benefit.applicableProducts.length === 0 ||
      benefit.applicableProducts.includes(item.productNumber);
    const appliesToCategory =
      !Array.isArray(benefit?.applicableCategories) ||
      benefit.applicableCategories.length === 0 ||
      (Array.isArray(item.categories) &&
        item.categories.some((category) =>
          benefit.applicableCategories.includes(category?.categoryNumber),
        ));

    if (!appliesToProduct || !appliesToCategory) {
      return;
    }

    switch (benefit?.type) {
      case 'percentage':
        itemDiscount +=
          (Number(item.price || 0) * Number(benefit.value || 0)) / 100;
        break;
      case 'fixed':
        itemDiscount += Number(benefit.amount || benefit.value || 0);
        break;
      case 'buy_x_get_y': {
        const isTarget =
          !benefit.productId ||
          String(benefit.productId) === String(item.productNumber);
        const buyQty = Number(benefit.buyQty || benefit.buyQuantity || 0);
        const getQty = Number(benefit.getQty || benefit.getQuantity || 0);

        if (isTarget && buyQty > 0 && Number(item.qty || 0) >= buyQty) {
          freeQty += Math.floor(Number(item.qty || 0) / buyQty) * getQty;
        }
        break;
      }
      default:
        break;
    }
  });

  return {
    discountedPrice:
      itemDiscount > 0
        ? Math.max(0, Number(item.price || 0) - itemDiscount)
        : Number(item.price || 0),
    freeQty,
    hasDiscount: itemDiscount > 0,
  };
}

export function filterVisibleCartItems(items = [], appliedBenefits = []) {
  const hasBuyXGetY = appliedBenefits.some(
    (benefit) => benefit?.type === 'buy_x_get_y',
  );

  if (!hasBuyXGetY) {
    return items;
  }

  return items.filter((item) => {
    if (!item?.isGift) {
      return true;
    }

    const hasMatchingNonGift = items.some(
      (candidate) =>
        !candidate?.isGift && candidate?.productNumber === item?.productNumber,
    );

    return !hasMatchingNonGift;
  });
}

export function hasFreeShippingBenefit(appliedBenefits = []) {
  return Array.isArray(appliedBenefits)
    ? appliedBenefits.some((benefit) => benefit?.type === 'free_shipping')
    : false;
}

export function getBenefitLabel(benefit, messages) {
  switch (benefit?.type) {
    case 'free_shipping':
      return readCartMessage(
        messages,
        'cart',
        'subtotalCard.freeShipping',
        'Free shipping',
      );
    case 'percentage':
      return `${benefit.value ?? 0}% ${readCartMessage(
        messages,
        'cart',
        'subtotalCard.off',
        'off',
      )}`;
    case 'fixed':
      return `${Number(benefit.amount ?? benefit.value ?? 0)} ${readCartMessage(
        messages,
        'cart',
        'subtotalCard.off',
        'off',
      )}`;
    case 'buy_x_get_y':
      return readCartMessage(
        messages,
        'cart',
        'subtotalCard.benefit',
        'Benefit',
      );
    default:
      return (
        benefit?.label ||
        readCartMessage(messages, 'cart', 'subtotalCard.benefit', 'Benefit')
      );
  }
}
